import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import Paginate from "vuejs-paginate-next";
import store from "./store";
import VueSvgInlinePlugin from "vue-svg-inline-plugin";
import VueWebpImage from "vue-webp-image";
import VueAgile from "vue-agile";



// import Vuelidate from "vuelidate";

import "normalize.css";
import "./registerServiceWorker";
import VueCookies from 'vue-cookies'

createApp(App)
  .use(router)
  .use(store)
  .use(VueSvgInlinePlugin)
  .use(VueWebpImage)
  .use(VueAgile)
  .use(VueCookies)
  .component('paginate', Paginate)
  .mount("#app");
